export const QUESTION_COUNTER_HEIGHT = 44;
export const SIMPLE_VOICE_ASSISTANT_HEIGHT = 140;
export const ASSESSMENT_MENU_HEIGHT = 52;
export const ASSESSMENT_MENU_HEIGHT_MOBILE = 156;
export const BOTTOM_SPACING_HEIGHT = 20;
export const CONTENT_CONTAINER_PADDING = 20;
